<template>
    <div class="footer__logo">
        <div class="footer__logo">
        <a
            v-if="isAuth"
            :href="$getSubdomainLink('portal', '/home')"
        >
            <img src="@/assets/images/logo.svg" :alt="appName" />
        </a>
        <a v-else :href="$getSubdomainLink('', '/')">
            <img src="@/assets/images/logo.svg" :alt="appName" />
        </a>
    </div>
    </div>
</template>

<script>
import config from '@/config'
export default {
    data() {
        return {
            appName: config.appName,
        };
    },
};
</script>
